export default __webpack_public_path__ + "static/media/atena-solutions-horizontal.3fdb818a.svg";